import { useQuery } from '@tanstack/react-query'

import { CollectionQueryKey } from '../helpers/queryKeys'
import { getCollectionSimple } from '../services/getCollectionSimple'

export const useCollectionSimple = ({ username, slug }: { username: string; slug: string }) => {
    return useQuery({
        queryKey: CollectionQueryKey.authorCollectionSimple(username, slug),
        queryFn: ({ signal }) => getCollectionSimple({ username, slug, signal }),
        enabled: Boolean(username && slug),
    })
}
